import { ContentBlock, EditorState, SelectionState } from 'draft-js';
import { FollowupData } from '../types';
import getFollowupTextPos, { StrLoc } from '../utils/getFollowupTextPos';
import { pipe } from '@repo/utils/helpers/operators';

export default (
  editorState: EditorState,
  followupData: FollowupData,
  blockKey: string,
): SelectionState => {
  return pipe(
    (blockKey: string) => editorState.getCurrentContent().getBlockForKey(blockKey),
    (block: ContentBlock) => getFollowupTextPos(followupData.text, block),
    (loc: StrLoc) =>
      editorState.getSelection().merge({
        anchorOffset: loc.begin,
        focusOffset: loc.end,
        anchorKey: blockKey,
        focusKey: blockKey,
      }),
  )(blockKey);
};
